import { IRiskCategory } from 'APIPackage/CatalogsModule/interfaces/IRiskCategory';

import { IRiskCategorySelectOption } from '../interfaces/IRiskCategorySelectOption';

export const createRiskCategorySelectOption = (riskCategory: IRiskCategory): IRiskCategorySelectOption => ({
  ...riskCategory,
  label: riskCategory.name,
  value: riskCategory.code,
});
